import axiosInstance from "./AxiosInstance";

const token = "e532c7ba3d7dd872df0f67576c161969";

export function getPatients( pagination, pageid, search_by = "", search_keyword = "",sort_order = "",sort_by = "") {
  return axiosInstance.post("/admin/patientList", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_order,sort_by
  });
}

export function getPatientlistbygender( gender) {
  return axiosInstance.post("/admin/patientListByGender", { gender });
}

export function getPatientDetails( patient_id) {
  return axiosInstance.post("/admin/patientDetails", { patient_id});
}
// export function createPatient( patientData) {
//   return axiosInstance.post('/admin/addPatient', patientData,{headers:{'Content-Type': 'multipart/form-data'}});
// }
// export function createPatient(patientData) {
//   return axiosInstance.post('/admin/addPatient', patientData, {
//       'Authorization': `Bearer ${localStorage.getItem("authToken")}` // Replace with actual auth mechanism
//     }
//   });
// }
export function createPatient(formData) {
  return axiosInstance.post("/admin/addPatient", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function addMarriageInfo(marriageData) {
  return axiosInstance.post("/admin/addMarriageInfo", marriageData);
}
export function addAddressInfo(addressData) {
  return axiosInstance.post("/admin/addAddressInfo", addressData);
}

export function addOtherInfo(formData) {
  return axiosInstance.post("/admin/addOtherInfo", formData);
}



export function updatePatient(formData) {
  return axiosInstance.post("/admin/updatePatient", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deletePatient(patient) {
  return axiosInstance.post(`/admin/deletePatient`, patient);
}

export function getFamilyTreeList(patientId) {
  return axiosInstance.post("/patient/familyTreeList", { patient_id: patientId })
}

export function addFamilyTree(data) {
  return axiosInstance.post("/patient/addFamilyTree", data)
}

export function editFamilyTree(data) {
  return axiosInstance.post("/patient/editFamilyTree", data)
}

export function deleteFamilyTree(data) {
  return axiosInstance.post("/patient/deleteFamilyTree", data)
}

export function formatPatients(responseData) {
  if (!responseData) return [];

  const getFullName = (p) =>
    [p.first_name, p.middile_name || p.middle_name, p.last_name]
      .filter(Boolean)
      .join(" ");

  if (Array.isArray(responseData)) {
    return responseData.map((patient) => ({
      patient_id: patient.patient_id || patient._id || patient.id,
      patient_name: getFullName(patient),
      patient_email: patient.patient_email,
      patient_dob: patient.date_of_birth,
      patient_phone:
        patient.whatsapp_contact_no || patient.additional_contact_no,
      patient_status: patient.patient_status,
    }));
  }

  let patients = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      const patient = responseData[key];
      patients.push({
        patient_id: patient.patient_id || patient._id || patient.id || key,
        patient_name: getFullName(patient),
        patient_email: patient.patient_email,
        patient_dob: patient.date_of_birth,
        patient_phone:
          patient.whatsapp_contact_no || patient.additional_contact_no,
        patient_status: patient.patient_status,
      });
    }
  }

  return patients;
}
